import { useTranslation } from "react-i18next";
import { twMerge } from "tailwind-merge";
import { SVGs } from "../assets";
import { Constants } from "../utils";
import { Tags } from "../libs";
import { TagsEvent, TagsContentType, TagsId } from "../libs/tags";
import Divider from "./Divider";
import Button from "./Button";
import Text from "./Text";

const socials = [
  {
    label: "Facebook",
    icon: SVGs.facebook,
    href: Constants.urls.facebook,
  },
  {
    label: "Twitter",
    icon: SVGs.twitter,
    href: Constants.urls.twitter,
  },
  {
    label: "Instagram",
    icon: SVGs.instagram,
    href: Constants.urls.instagram,
  },
  {
    label: "LinkedIn",
    icon: SVGs.linkedin,
    href: Constants.urls.linkedin,
  },
];

export type FooterProps = {
  className?: string;
};

export default function Footer({ className }: FooterProps) {
  const { t } = useTranslation();

  return (
    <footer
      className={twMerge(
        "bg-secondary  px-[20px] lg:px-[80px]  py-[40px]",
        className,
      )}
    >
      <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-[20px]">
        <div className="flex w-full flex-wrap items-center gap-[40px] sm:w-auto">
          {socials.map((social) => (
            <a
              target="_blank"
              href={social.href}
              key={social.href}
              aria-label={social.label}
              rel="noopener noreferrer"
              onClick={() =>
                Tags.event(TagsEvent.SocialClick, { platform: social.label })
              }
            >
              <img
                src={social.icon}
                alt={social.label}
                className="h-[28px] w-[28px]"
              />
            </a>
          ))}
        </div>
        <div className="flex w-full items-center gap-[15px] sm:w-auto">
          <a
            target="_blank"
            href={Constants.urls.contactUs}
            rel="noopener noreferrer"
            className="flex-1 sm:flex-none"
            onClick={() =>
              Tags.event(TagsEvent.SelectContent, {
                content_type: TagsContentType.FooterLink,
                item_id: TagsId.ContactUs,
              })
            }
          >
            <Button
              className="w-full"
              color="secondary"
              children={t("footer.contactUs")}
            />
          </a>
          <a
            target="_blank"
            href={Constants.urls.sendFeedback}
            rel="noopener noreferrer"
            className="flex-1 sm:flex-none"
            onClick={() =>
              Tags.event(TagsEvent.SelectContent, {
                content_type: TagsContentType.FooterLink,
                item_id: TagsId.SendFeedback,
              })
            }
          >
            <Button
              className="w-full"
              color="secondary"
              children={t("footer.sendFeedback")}
            />
          </a>
        </div>
      </div>
      <Divider className="my-[20px]" color="border" />
      <div className="flex items-center gap-[10px] justify-between">
        <Text className="text-surface">{t("footer.copyright")}</Text>
        <Text className="text-surface">
          {t("footer.dataQuestion")}{" "}
          <Text
            as="a"
            href={Constants.urls.privacy}
            target="_blank"
            rel="noopener noreferrer"
            className="text-primary"
            children={t("footer.privacy")}
            onClick={() =>
              Tags.event(TagsEvent.SelectContent, {
                content_type: TagsContentType.LegalLink,
                item_id: TagsId.PrivacyPolicy,
              })
            }
          />
        </Text>
      </div>
    </footer>
  );
}
